/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Uploading_Please_WaitInputs */

const en_uploading_please_wait = /** @type {(inputs: Uploading_Please_WaitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uploading... please wait`)
};

const fr_uploading_please_wait = /** @type {(inputs: Uploading_Please_WaitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Téléversement... veuillez patienter`)
};

const de_uploading_please_wait = /** @type {(inputs: Uploading_Please_WaitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wird hochgeladen... bitte warten`)
};

const it_uploading_please_wait = /** @type {(inputs: Uploading_Please_WaitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caricamento in corso... attendere prego`)
};

const ru_uploading_please_wait = /** @type {(inputs: Uploading_Please_WaitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Загрузка... пожалуйста, подождите.`)
};

const es_uploading_please_wait = /** @type {(inputs: Uploading_Please_WaitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subiendo... por favor espere`)
};

const zh_cn2_uploading_please_wait = /** @type {(inputs: Uploading_Please_WaitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在上传……请稍候`)
};

const ja_uploading_please_wait = /** @type {(inputs: Uploading_Please_WaitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アップロード中...お待ちください`)
};

const hi_uploading_please_wait = /** @type {(inputs: Uploading_Please_WaitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अपलोड हो रहा है... कृपया प्रतीक्षा करें`)
};

const pt_pt2_uploading_please_wait = /** @type {(inputs: Uploading_Please_WaitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carregando... aguarde`)
};

/**
* | output |
* | --- |
* | "Uploading... please wait" |
*
* @param {Uploading_Please_WaitInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const uploading_please_wait = /** @type {((inputs?: Uploading_Please_WaitInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uploading_Please_WaitInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_uploading_please_wait(inputs)
	if (locale === "de") return de_uploading_please_wait(inputs)
	if (locale === "it") return it_uploading_please_wait(inputs)
	if (locale === "ru") return ru_uploading_please_wait(inputs)
	if (locale === "es") return es_uploading_please_wait(inputs)
	if (locale === "zh-CN") return zh_cn2_uploading_please_wait(inputs)
	if (locale === "ja") return ja_uploading_please_wait(inputs)
	if (locale === "hi") return hi_uploading_please_wait(inputs)
	if (locale === "pt-PT") return pt_pt2_uploading_please_wait(inputs)
	return en_uploading_please_wait(inputs)
});